"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var discountPriceValueStyles = styles_1.makeStyles(function (theme) { return ({
    boldPrice: {
        fontWeight: 'bold',
        fontSize: theme.typography.fontMD,
        wordBreak: 'break-word',
    },
    price: {
        fontSize: theme.typography.fontMD,
    },
    priceContainer: {
        textAlign: 'end',
    },
}); }, { name: 'Summary_PriceValue' });
exports.default = discountPriceValueStyles;
